export default "__VITE_ASSET__DOr4usT___"